import { configureStore } from "@reduxjs/toolkit";
import toggleSidebarReducer from '../slices/toggleSidebarSlice';
import toggleTableReducer from '../slices/toggleTableSlice';
import authReducer from '../slices/loginSlice';
import versionControlReducer from "../slices/versionControlSlice"
import userProfileSlice from "../slices/userProfileSlice"
import campaignReducer from "../slices/campaignSlice"
import adPlacementDetailsReducer from "../slices/adPlacementDetailsSlice"
import paymentReducer from "../slices/paymentSlice"
import audienceInsightReducer from "../slices/audienceInsightSlice"

const asyncDispatchMiddleware = (store) => (next) => (action) => {
    if (typeof action === "function") {
        return action(store.dispatch, store.getState);
    }
    return next(action);
};

export const store = configureStore({
    reducer: {
        toggleTable: toggleTableReducer,
        toggleSidebar: toggleSidebarReducer,
        auth: authReducer,
        versionControl: versionControlReducer,
        userProfile: userProfileSlice,
        campaign: campaignReducer,
        adPlacementDetails: adPlacementDetailsReducer,
        payment: paymentReducer,
        audienceInsight: audienceInsightReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(asyncDispatchMiddleware),
});

export default store;